export default __webpack_public_path__ + "static/media/store.857229fb.png";